<template>
  <!-- 组织机构 -->
 <div class="treeBigBox">
    <!--树形结构-->
    <div class="box">
      <div class="title">
        <div class="xian"></div>
        <div>业务组织</div>
      </div>
      <div class="treeBox">
        <el-button type="primary" @click="addClick('addForm')" style="margin-bottom:20px">添加父业务</el-button>
        <div class="boxScroll">
          <el-tree :data="data"
            node-key="id"
            ref="orgTree"
            :props="defaultProps"
            :default-expand-all="true"
            :expand-on-click-node="false"
            :current-node-key="currentData.id"
            :highlight-current="true"
            :render-content="renderContent"
            @node-click="handleNodeClick">
          </el-tree>
        </div>
      </div>
    </div>
    <!--详情标题-->
    <div class="right">
      <div class="title">
        <div class="xian"></div>
        <div>业务列表</div>
      </div>

      <div>
         <div class="centerBox">
         <div class="rightTop">
            <h4 ref="shangJiName">{{currentData.title1}}</h4>
            <el-button type="primary" @click="childClick">添加</el-button>
         </div>
      <!--详情-->
      <div class="xiangQingBox">
        <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table"  highlight-current-row   v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
          height="100%" style="width: 100%" center border>
            <el-table-column type="index" prop="date" width="50" label="序号"></el-table-column>
            <el-table-column label="操作" width="160" >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" @click="role(scope.row)" v-if="scope.row.children.length == 0">关联角色</el-button>
                  <el-button type="text" size="mini" @click="editFn1(scope.row)">修改</el-button>
                  <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="160"  label="业务名称" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
            <el-table-column prop="code" min-width="150"   label="业务编码" :formatter="emptyFn"></el-table-column>
            <el-table-column property="sourceType" label="开通客户端" min-width="100">
              <template scope="scope">
                <div>
              {{[ "否", "是"][scope.row.openFlag]}}
                </div>
              </template>
            </el-table-column>
            <el-table-column property="showFlag" label="展示方式" min-width="150">
              <template scope="scope">
                <div>
              {{[ "按开通租户展示", "按业务名称展示"][scope.row.showFlag]}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark"  min-width="260" label="业务描述" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createUserName" label="创建人"  width="120" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
          </el-table>
        </div>
      </div>
      </div>
      </div>
    </div>
    <el-dialog  :title="title"  :visible.sync="addMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="addForm" ref="addForm" :rules="rules" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0">
            <el-form-item label="业务名称:" prop="name">
              <el-input v-model="addForm.name" placeholder="" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="业务描述:" prop="remark">
              <el-input type="textarea" v-model="addForm.remark" style="width:197px" rows="4"  maxlength="50"></el-input>
            </el-form-item>
          </div>
          <p style="color:red;margin-left:35px">备注：请维护标准业务名称，尽可能维护完整备注信息！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMark = false">取消</el-button>
        <el-button type="primary" @click="addSave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
   <el-dialog  :title="title"  :visible.sync="childMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="addForm" ref="addForm" :rules="rules1" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0">
            <el-form-item label="子业务名称:" prop="name">
              <el-input v-model="addForm.name" placeholder="" maxlength="10"></el-input>
            </el-form-item>
            <!-- <el-form-item label="开放对象:" prop="openObjs1">
              <el-select v-model="addForm.openObjs1" multiple placeholder="请选择">
                <el-option v-for="val in kfdx" :label="val.name" :value="val.id" :key="val.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="开通客户端:" prop="openFlag" class="ziti">
               <template >
                <el-radio-group v-model="addForm.openFlag">
                  <el-radio :label="1" >是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="展示方式:" prop="showFlag">
                <el-select placeholder="请选择" v-model="addForm.showFlag">
                  <el-option
                    v-for="item in bussinessType"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="业务描述:" prop="remark">
              <el-input type="textarea" v-model="addForm.remark" style="width:197px" rows="4" maxlength="50"></el-input>
            </el-form-item>
          </div>
          <p style="color:red;margin-left:35px">备注：请维护标准业务名称，尽可能维护完整备注信息！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="childMark = false">取消</el-button>
        <el-button type="primary" @click="childsave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
   <el-dialog  :title="title"  :visible.sync="roleAddMark" width="960px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <el-form :inline="true"  :model="addForm" ref="addForm" :rules="rules" class="demo-form-inline jiaoyan" label-width="200px" size="mini">
        <div style="margin: 28px 0;" class="juese">
          <el-radio-group v-model="addForm.roleId">
            <el-radio v-for="item in roleType"
                      :key="item.id"
                      :label="item.id"
                      @click.native.prevent="clickitem(item.id)"
                    > <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                      <span>{{item.name}}</span></el-tooltip></el-radio>
          </el-radio-group>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleAddMark = false" size="mini">取消</el-button>
        <el-button type="primary" @click="roleAddSave()" size="mini">确定</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import {
  businessTree, // 结构树
  addParentBusiness, // 业务添加
  addBusiness, // 子业务添加
  sBusinessUpdate, // 修改
  sBusinessDelete, // 删除
  businessRole, // 获取
  sBusinessRole, // 关联角色
  businessRoleRel // 回显
} from '@/api/newCrm'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      bussinessType: [
        { name: '按开通租户展示', value: 0 },
        { name: '按业务名称展示', value: 1 }
      ],
      // 关联角色
      roleAddMark: false,
      roleType: [],
      Role: false,
      addBtnShow: false,
      editBtnShow: false,
      kfdx: [
        // { name: "请选择", id: ''},
        { name: '租户', id: '1' },
        { name: '客户', id: '2' },
        { name: '注册', id: '3' }
      ],
      childMark: false,
      addForm: {
        roleId: []
      },
      addMark: false,
      currentData: {}, // 当前选中
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      loading: false,
      title: '',
      title1: '',
      // 组织机构树
      data: [],
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      h: '500px',
      // 新增验证
      rules: {
        name: [
          { required: true, message: '请输入业务名称', trigger: 'blur' }
        ]
      },
      rules1: {
        name: [
          { required: true, message: '请输入子业务名称', trigger: 'blur' }
        ],
        openObjs1: [
          { required: true, message: '请选择开放对象', trigger: 'blur' }
        ],
        openFlag: [
          { required: true, message: '请选择是否开通客户端', trigger: 'blur' }
        ],
        showFlag: [
          { required: true, message: '请选择展示方式', trigger: 'blur' }
        ]
      },
      busiFlag: true,
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P003B001', '000P003B002', '000P003B003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/zuZhiJiGou')
    this.getTree(true)
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 160) + 'px'
  },
  methods: {
    // 单选取消
    clickitem (e) {
      if (e == this.addForm.roleId) {
        this.$set(this.addForm, 'roleId', '')
      } else {
        this.$set(this.addForm, 'roleId', e)
      }
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      let newArr = []
      let arr = cellValue.split(',')
      // console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == '1') {
          newArr.push('租户')
        } else if (arr[i] == '2') {
          newArr.push('客户')
        } else if (arr[i] == '3') {
          newArr.push('注册')
        }
      }
      return newArr.toString()
    },
    // 树得格式化
    renderContent (h, { node, data, store }) {
      // console.log(node)
      if (node.level == 1 && data.remark) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">
              {data.name }
              <el-tooltip class="item" effect="dark" content={data.remark} placement="top-start" >
                <i class="el-icon-info"></i>
              </el-tooltip>
              <i class="el-icon-edit" on-click={ () => this.editFn(data) }></i>
              <i class="el-icon-delete" on-click={ () => this.delFn(data) }></i>
            </span>
          </span>)
      } else if (node.level == 1 && !data.remark) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">
              {data.name }
              <i class="el-icon-edit" on-click={ () => this.editFn(data) }></i>
              <i class="el-icon-delete" on-click={ () => this.delFn(data) }></i>
            </span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name }</span>
          </span>)
      }
    },

    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },

    // 获取左侧菜单
    getTree (flag) {
      businessTree().then((res) => {
        this.data = res
        if (this.data.length != 0) {
          this.$nextTick(function () {
          // console.log(this.$refs.orgTree)
            if (this.$refs.orgTree) {
              this.$refs.orgTree.setCurrentKey(this.currentData.id)
              // console.log(this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children +"列表")
              // console.log(this.$refs.orgTree.getNode(this.currentData.id));
              this.tableList = this.$refs.orgTree.getNode(this.currentData.id).data.children
            }
          })

          if (flag) {
            this.currentData = {
              title1: this.data[0].name,
              parentId: this.data[0].parentId,
              id: this.data[0].id
            }
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击树
    handleNodeClick (data) {
      this.tableList = data.children
      this.currentData = {
        title1: data.name,
        id: data.id,
        parentId: data.parentId
      }
    },
    role (row) {
      // console.log(row);
      this.$set(this.addForm, 'id', row.id)
      this.roleAddMark = true
      this.title = '关联角色'
      businessRole().then(res => {
        this.roleType = res
        businessRoleRel({ id: row.id }).then(res => {
          //  console.log(res);
          this.addForm.roleId = res
        })
      })
    },
    roleAddSave () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          // this.$set(this.addForm, 'id', row.id)
          sBusinessRole(this.addForm).then(res => {
            loading.close()
            this.$message({
              message: '关联成功',
              type: 'success'
            })
            this.roleAddMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 添加业务
    addClick () {
      this.title = '添加业务'
      this.addMark = true
      this.addBtnShow = true
      this.editBtnShow = false
    },
    // 添加保存
    addSave () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addParentBusiness(this.addForm).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 二级
    childClick () {
      this.title = '添加子业务'
      this.childMark = true
      this.addBtnShow = true
      this.editBtnShow = false
      if (this.$refs['addForm']) {
        this.$refs['addForm'].clearValidate()
      }
    },
    // 添加保存
    childsave () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.$set(this.addForm, 'id', this.currentData.id)
          // this.$set(this.addForm, 'parentId', this.currentData.parentId)
          addBusiness(this.addForm).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.childMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改业务
    editFn (row) {
      this.title = '修改业务'
      this.addMark = true
      this.addBtnShow = false
      this.editBtnShow = true
      this.addForm = { ...row }
      this.$set(this.addForm, 'parentId', this.currentData.parentId)
      this.busiFlag = true
    },
    // 修改子业务
    editFn1 (row) {
      this.title = '修改子业务'
      this.childMark = true
      this.addBtnShow = false
      this.editBtnShow = true
      this.busiFlag = false
      this.addForm = {
        id: row.id,
        parentId: row.parentId,
        name: row.name,
        remark: row.remark,
        openFlag: row.openFlag,
        showFlag: row.showFlag
      }
    },
    editSave () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sBusinessUpdate(this.addForm).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.addMark = false
            this.childMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sBusinessDelete({ parentId: row.parentId, id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTree()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },

    closeDialog () {
      this.addForm = {
        roleId: []
      }
      if (this.$refs['addForm']) {
        this.$refs['addForm'].clearValidate()
      }
      // this.$refs['addForm'].resetFields()
    }

  }
}
</script>

<style scoped lang='less'>
  /deep/.custom-tree-node{
    i{
      margin: 0 5px;
    }
  }
  .treeBigBox{
    height:100%;
    display:flex;
  }
  .treeBox{
    padding:20px 0 0 20px;
  }
  .centerBox{
    width:100%;
    height:100%;
  }
  .xiangQingBox{
    margin-top: 10px;
  }
 .demo-form-inline .el-form-item{
  margin-bottom: 17px!important;
}
.rightTop{
  display: flex;
  padding: 0 30px;
  align-items: center;
  h4{
    padding-right: 30px;
  }
}
.title{
  width: 100%;
  height: 36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  margin-top: -12px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right{
  // flex: 1;
  // width: 75%;
  width: calc(100% - 361px);
}
.box{
  // width:28%;
  width: 360px;
  border-right: 1px dashed #ddd;
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.juese /deep/.el-radio__label {
  font-size: 16px;
}
/deep/.inpBox .el-input__inner {
  width: 197px;
}
.juese .el-radio, .el-radio__input {
    line-height: 2;
    outline: 0px;
    white-space: nowrap;
}
// .el-radio:hover{
//     width: 100%;
//     overflow:visible;
//     white-space: nowrap;
// }
.juese /deep/.el-radio {
    color: #606266;
    cursor: pointer;
    margin-right: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 210px;
}
.boxScroll{
  height: calc(100vh - 160px);
  overflow: auto;
}
</style>
